import styles from "../../index.module.less";
import {CallModal} from "@/pages/callTool/intelligentOutboundCall/components/Info/CallModal.tsx";
import {useAtom} from "jotai";
import {callListAtom} from "@/pages/callTool/intelligentOutboundCall/components/Info/store";

export const Info = () => {
  const [callList] = useAtom(callListAtom)

  return <div className={styles.infoBox}>
    {/*<div className={styles.taskBox}>
      <div className={styles.title}>任务信息</div>
      <div className={styles.flexBetween}>
        <div className={styles.taskItemEllipsis}>任务标题：签单回访</div>
        <div className={styles.taskItemEllipsis}>任务完成标准：截止时间前完成电话回访并录入跟进日志</div>
        <div className={styles.taskItemEllipsis}>任务截止时间：2025-04-10 23:59:59</div>
      </div>
    </div>*/}
      <CallModal clueId={callList?.userInfo?.id} key={callList?.userInfo?.id}/>
  </div>
}